import { apiUrl } from './api-client';

export function getPortalFileHref(file) {
  return apiUrl(file?.download_url || '');
}

export function formatPortalFileDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function splitPortalFiles(files = []) {
  return files.reduce((acc, file) => {
    if (file.visibility === 'public') {
      acc.publicFiles.push(file);
    } else {
      acc.privateFiles.push(file);
    }
    return acc;
  }, { publicFiles: [], privateFiles: [] });
}
